@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackGridWhite {
  display: flex;
  gap: 50px;
  flex-direction: column;

  .line {
    display: flex;
    gap: 50px;

    .entry {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      gap: 15px;

      &.large {
        width: 67.7%;

        .imageContainer {
          align-items: flex-end;
        }
      }

      .imageContainer {
        height: 305px;
        width: 100%;
        background: #F8F9FA;
        border: 1px solid #EDEDED;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;

        .illus {
          height: 215px;
          width: 215px;

          &.metrics {
            @include icons.ico("illus-metrics");
          }

          &.languages {
            @include icons.ico("illus-languages-white");
          }

          &.score {
            @include icons.ico("colored-speedometer-black");
          }

          &.editor {
            @include icons.ico("illus-editor-collaboration");
          }

          &.topicsFire, &.topicsShield, &.topicsScore, &.optimize, &.pageSimple, &.pageBlog, &.pageProduct {
            position: absolute;
            left: -60px;
            bottom: -20px;
            width: 315px;
            height: 315px;

            &.topicsFire {
              filter: var(--icon-fire);

              @include icons.ico("black-fire");
            }

            &.topicsScore {
              @include icons.ico("colored-speedometer-black");
            }

            &.topicsShield {
              filter: var(--icon-web-green);

              @include icons.ico("black-shield");
            }

            &.optimize {
              filter: var(--icon-web-green);

              @include icons.ico("black-pos-track");
            }

            &.pageSimple {
              @include icons.ico("black-page-simple");
            }

            &.pageBlog {
              @include icons.ico("black-page-blog");
            }

            &.pageProduct {
              @include icons.ico("black-page-product");
            }
          }
        }

        .img {
          width: calc(100% - 40px);
          max-width: 580px;
          transform: translateY(150px) scale(0.9);

          &.leftBottom {
            left: 0;
            bottom: 0;
            position: absolute;
            width: unset;
            height: 100%;
          }
        }
      }

      .title {
        font-size: 20px;
        text-align: center;

        @include texts.font("semi-bold");
      }

      .description {
        font-size: 15px;
        color: var(--grey-text);
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 930px) {

    .line {
      flex-direction: column;

      .entry {
        width: 100% !important;

        .imageContainer {
          height: 190px !important;

          .illus {
            height: 140px !important;
            width: 140px !important;

            &.topicsFire {
              width: 205px !important;
              height: 205px !important;
            }

            &.topicsShield {
              width: 205px !important;
              height: 205px !important;
            }
          }
        }
      }
    }
  }
}